import React from 'react';
import { ITaskRunner } from '@singularsystems/neo-core';
import { Neo, NeoGrid, Views } from '@singularsystems/neo-react';
import AuthorisableUpdateRequestsByStatusVM from './AuthorisableUpdateRequestsByStatusVM';
import { observer } from 'mobx-react';
import { TextConstants } from '../../../../Common/TextConstants';
import AuthorisableUpdateRequestBatchLookup from '../Models/Lookups/AuthorisableUpdateRequestBatchLookup';

interface IAuthorisableUpdateRequestsByStatusProps {
    viewModel: AuthorisableUpdateRequestsByStatusVM
}

class AuthorisableUpdateRequestsByStatusViewParams {
    public authorisableStatus = {}  
}

@observer
export default class AuthorisableUpdateRequestsByStatus extends React.Component<IAuthorisableUpdateRequestsByStatusProps> {
 
    public render() {
        const viewModel = this.props.viewModel;

        return (
            <>              
               <Neo.Pager pageManager={viewModel.authorisableUpdateRequestPageManager} pageControlProps={{pageSizeLabel: "Show"}}>
                        <div className='horizontalScroll inner-container'>                           
                            <NeoGrid.Grid<AuthorisableUpdateRequestBatchLookup> className={"table-striped"}>
                                {(item, meta) => (
                                    <NeoGrid.RowGroup expandProperty={meta.isExpanded}>
                                        <NeoGrid.Row>
                                            <NeoGrid.Column display={meta.userNotes} />    
                                            <NeoGrid.Column display={meta.serviceProviderName} label={TextConstants.Labels.Broker} />
                                            <NeoGrid.Column display={meta.numberOfUpdatesInBatch} label={TextConstants.Labels.NumberOfUpdates} />
                                            <NeoGrid.Column display={meta.dateCreated} label={TextConstants.Labels.DateCreated} />
                                            {viewModel.isPending &&
                                            <NeoGrid.ButtonColumn>
                                                                <Neo.Button
                                                                    onClick={() => viewModel.declineBatch(item.authorisableUpdateRequestBatchId)}
                                                                    variant="primary" isOutline className="btn-link">{TextConstants.Buttons.DeclineBatch}</Neo.Button>
                                                                <Neo.Button
                                                                    onClick={() => viewModel.processRequestsByBatch(item.authorisableUpdateRequestBatchId, item.staticServiceProviderId)}
                                                                    variant="primary" isOutline className="btn-link">{TextConstants.Buttons.ProcessBatch}</Neo.Button>
                                            </NeoGrid.ButtonColumn>
                                            }                                  
                                        </NeoGrid.Row>
                                    {item.authorisableUpdateableTableRequestLookups.length > 0 &&
                                        <NeoGrid.ChildRow>
                                            <NeoGrid.Grid 
                                            items = {item.authorisableUpdateableTableRequestLookups}>
                                                {(child, childMeta) => (
                                                    <NeoGrid.Row>
                                                        <NeoGrid.Column display={childMeta.tableName} label={TextConstants.Labels.AffectedTable} />
                                                        <NeoGrid.Column display={childMeta.fieldName} label={TextConstants.Labels.FieldName}/>
                                                        <NeoGrid.Column display={childMeta.oldValue} label={TextConstants.Labels.OldValue} />
                                                        <NeoGrid.Column display={childMeta.newValue} label={TextConstants.Labels.NewValue} />
                                                        <NeoGrid.Column display={childMeta.additionalInfo} label={TextConstants.Labels.AdditionalInformation} />
                                                    </NeoGrid.Row>
                                                )}
                                            </NeoGrid.Grid>
                                        </NeoGrid.ChildRow>}
                                    </NeoGrid.RowGroup>                                    
                                )}
                            </NeoGrid.Grid>

                            {viewModel.authorisableUpdateRequestPageManager.totalRecords == 0 &&
                             <div className="col-md-12 text-center">{TextConstants.GeneralText.NoRecords}</div>}
                        </div>
                </Neo.Pager>
               
            </>
        );
    }
}